import { z } from 'zod';

export const CHANNELS = ['EMAIL', 'SMS', 'WHATSAPP', 'PUSH', 'IN_APP', 'WEBHOOK'] as const;
export const ChannelEnum = z.enum(CHANNELS);

export const channelConfigSchema = z.object({
  id: z.string(),
  appId: z.string(),
  tenantId: z.string().optional(),
  channel: z.string(),
  fromAddress: z.string(),
  fromName: z.string().nullable(),
  replyTo: z.string().nullable(),
  createdAt: z.string(),
  updatedAt: z.string(),
  /** `cac` cuando la fila la declara el CaC de la app: se muestra bloqueada. */
  managedBy: z.string().nullable().optional(),
});
export type ChannelConfig = z.infer<typeof channelConfigSchema>;

export const channelConfigInputSchema = z.object({
  fromAddress: z.string().min(1, 'From address is required'),
  fromName: z.string().optional(),
  replyTo: z.string().email('Must be a valid email').optional().or(z.literal('')),
});
export type ChannelConfigInput = z.infer<typeof channelConfigInputSchema>;
